import { IdVerificationRecordDialog } from '@/bundle/shared/components/IdVerificationRecordDialog/IdVerificationRecordDialog';
import { useQuery } from '@tanstack/react-query';
import { INVOICE_VAULT_QUERY_KEYS, loadInvoiceCheckVerification } from '../../../api/api';

type InvoiceCheckVerificationModalType = {
  id: string;
  onClose: () => void;
};

export const InvoiceCheckVerificationModal = ({ id, onClose }: InvoiceCheckVerificationModalType) => {
  const { data, isPending } = useQuery({
    queryKey: [INVOICE_VAULT_QUERY_KEYS.checks, id],
    queryFn: () => loadInvoiceCheckVerification(id),
  });
  const record = data?.body;

  return <IdVerificationRecordDialog isOpen onClose={onClose} record={record} isLoading={isPending} />;
};
